import React from 'react';
import SelectAllSwitch from './SelectAllSwitch';
import { ComponentType, VersionedComponentBusinessId } from '@cambridgeassessment/lib-ee-commons';
import { useDispatch, useSelector } from 'react-redux';
import { setComponentReplacementStatus } from '../../../../../store/replacementFiles/thunks';
import { useAuth } from 'oidc-react';
import { RootState } from '../../../../../store';

interface Props {
  isAllSelected: boolean;
  isAllAbsent?: boolean;
  componentType: ComponentType;
  componentBid: VersionedComponentBusinessId;
  componentIndex: number;
}

export const SelectAllToggle: React.FC<Props> = ({
  componentType,
  isAllAbsent,
  isAllSelected,
  componentBid,
  componentIndex,
}) => {
  const dispatch = useDispatch();
  const { userData } = useAuth();
  const { selectedRole } = useSelector((state: RootState) => state.userData);

  const onChange = (availableForResubmission: boolean) => {
    const resubmitter = availableForResubmission
      ? {
          name: userData?.profile.name,
          email: userData?.profile.email,
          role: selectedRole?.name || '',
        }
      : undefined;
    dispatch(setComponentReplacementStatus(componentBid, componentIndex, resubmitter));
  };

  if (componentType === ComponentType.MODERATED && isAllAbsent) {
    return <SelectAllSwitch onChange={onChange} checked={false} disabled={true} title={'All candidates are absent.'} />;
  } else {
    return (
      <SelectAllSwitch
        onChange={onChange}
        checked={isAllSelected}
        disabled={false}
        title={
          'This action will select all candidates for the component as requiring replacement files. If the component is moderated you may only want to select candidates selected within the sample. In this scenario ‘selecting all’ may not be appropriate.'
        }
      />
    );
  }
};

export default SelectAllToggle;
